import { useMemo } from "react";
import { nanoid } from "nanoid";
import { Row } from "../../components/Row";

export const Checklist = () => {
  const stableIds = useMemo(
    () => Array.from({ length: 4 }, () => nanoid()),
    [],
  );

  return (
    <>
      <div className="p-6">
        <div className="flex justify-between">
          <Row className="w-1/4" />
          <Row className="w-1/4" />
        </div>
        <div className="w-full">
          <Row className="mt-2 h-2 w-1/2" long almostFull />
        </div>
      </div>

      {stableIds.map(id => (
        <div key={id}>
          <div className="border-primary h-px w-full border-t" />
          <div className="flex w-full items-center justify-between p-6">
            <Row className="w-1/2 shrink-0" long />
            <Row square sm />
          </div>
        </div>
      ))}
    </>
  );
};
